module.exports = "/_next/static/images/photoOlgaMelnic-9da0df76c7b1ae5b1b301408316e3085.webp";